import React from 'react';
import { Link } from 'react-router-dom';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import {
  Avatar,
  Box,
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import { formatFe } from './fanEnergyLeaderboardUtils';

function LeaderboardTable({ entries, showGuestBadge }) {
  const colSpan = showGuestBadge ? 7 : 6;

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Rank</TableCell>
            <TableCell>User</TableCell>
            <TableCell>User ID</TableCell>
            <TableCell>Contact</TableCell>
            <TableCell align="right">FE earned</TableCell>
            {showGuestBadge && <TableCell>Type</TableCell>}
            <TableCell align="right">Action</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entries.length === 0 ? (
            <TableRow>
              <TableCell colSpan={colSpan} align="center">
                No leaderboard entries found.
              </TableCell>
            </TableRow>
          ) : (
            entries.map((entry) => {
              const isGuest = entry.subjectType === 'guest';
              const rowKey = isGuest ? `guest-${entry.guestHash}` : `user-${entry.userId}`;

              return (
                <TableRow key={rowKey} hover>
                  <TableCell>
                    <Typography fontWeight={700}>#{entry.rank}</Typography>
                  </TableCell>
                  <TableCell>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      {entry.profilePicUrl ? (
                        <Avatar src={entry.profilePicUrl} sx={{ width: 32, height: 32 }} />
                      ) : (
                        <Avatar sx={{ width: 32, height: 32, fontSize: 14 }}>
                          {(entry.name || entry.username || '?').charAt(0).toUpperCase()}
                        </Avatar>
                      )}
                      <Box>
                        <Typography variant="body2" fontWeight={600}>
                          {entry.name || entry.username || (isGuest ? 'Guest' : `User ${entry.userId}`)}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          @{entry.username || '—'}
                        </Typography>
                      </Box>
                    </Box>
                  </TableCell>
                  <TableCell>{isGuest ? '—' : entry.userId}</TableCell>
                  <TableCell>
                    {isGuest ? (
                      <Typography variant="body2" color="text.secondary">
                        —
                      </Typography>
                    ) : (
                      <>
                        <Typography variant="body2">{entry.email || '—'}</Typography>
                        <Typography variant="caption" color="text.secondary">
                          {entry.phone || '—'}
                        </Typography>
                      </>
                    )}
                  </TableCell>
                  <TableCell align="right">
                    <Typography fontWeight={700} sx={{ color: 'success.main' }}>
                      {formatFe(entry.totalEnergy)}
                    </Typography>
                  </TableCell>
                  {showGuestBadge && (
                    <TableCell>
                      <Chip
                        size="small"
                        label={isGuest ? 'Guest' : 'User'}
                        color={isGuest ? 'default' : 'primary'}
                        variant={isGuest ? 'outlined' : 'filled'}
                      />
                    </TableCell>
                  )}
                  <TableCell align="right">
                    {!isGuest && entry.userId ? (
                      <Button
                        component={Link}
                        to={`/admin/fan-ledger/${entry.userId}`}
                        size="small"
                        endIcon={<OpenInNewIcon />}
                      >
                        Fan Ledger
                      </Button>
                    ) : (
                      '—'
                    )}
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default LeaderboardTable;
